module.exports = __webpack_public_path__ + "img/fh_slider3.9b776dd3.jpg";